import { render } from "./user-modal.vue?vue&type=template&id=f1180f38"
import script from "./user-modal.vue?vue&type=script&lang=js"
export * from "./user-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__